/** Aviso de gravacao recusada (409 DOCUMENTO_JA_CADASTRADO): oferece usar o parceiro que ja tem o documento. */
export function AvisoDocumentoCadastrado({ nome, onUsar, desabilitado = false }: { nome: string; onUsar: () => void; desabilitado?: boolean }) {
  return (
    <div role="alert" className="mt-3 rounded-xl border border-border bg-line-soft px-4 py-3 text-small text-ink-body">
      Este CPF/CNPJ já está cadastrado para {nome}.{' '}
      <button type="button" className="font-medium text-primary underline disabled:opacity-50" onClick={onUsar} disabled={desabilitado}>
        Usar o parceiro existente
      </button>
    </div>
  );
}
